import { GstRadioTypes } from "../../../commonTypes/gstTypes";
import { RadioTypes } from "../../../commonTypes/universalTypes";
import { TableHeadersType } from "../tableHeadersType";

export const GST_EXEMPTION = [
  { label: "Nil Rated", value: "nil_rated" },
  { label: "Exempted Supply", value: "exempted_supply" },
  { label: "Non GST", value: "non_gst" },
  { label: "None", value: "" },
];

export const AGREE_DISAGREE_OPTIONS = [
  { label: "Yes", value: "Yes" },
  { label: "No - Other", value: "No - Other" },
  { label: "None", value: "" },
];

export const WHETHER_ELIGIBLE_OPTIONS = [
  { label: "Yes", value: "Yes" },
  { label: "No - 17(5)", value: "No - 17(5)" },
  { label: "No - 38(180 days)", value: "No - 38(180 days)" },
  { label: "No - 42, 43", value: "No - 42, 43" },
  { label: "No - 16(4)", value: "No - 16(4)" },
  { label: "No - PoS Rules", value: "No - PoS Rules" },
  { label: "No - Other", value: "No - Other" },
  { label: "No - 17(5), D(1)", value: "No - 17(5), D(1)" },
  { label: "No - 38(180 days), D(1)", value: "No - 38(180 days), D(1)" },
  { label: "No - 42, 43, D(1)", value: "No - 42, 43, D(1)" },
  { label: "No - Other, D(1)", value: "No - Other, D(1)" },
  { label: "No - 17(5), D(2)", value: "No - 17(5), D(2)" },
  { label: "No - 38(180 days), D(2)", value: "No - 38(180 days), D(2)" },
  { label: "No - 42, 43, D(2)", value: "No - 42, 43, D(2)" },
  { label: "No - Other, D(2)", value: "No - Other, D(2)" },
  { label: "None", value: "" },
];

export const REVERSE_CHARGE_OUTWARD_OPTIONS = [
  { label: "Yes", value: "Yes" },
  { label: "No", value: "No" },
  { label: "None", value: "" },
];

export const REVERSE_CHARGE_INWARD_OPTIONS = [
  { label: "Yes", value: "Yes" },
  { label: "Yes - 9(5)-ECO", value: "Yes - 9(5)-ECO" },
  { label: "No", value: "No" },
  { label: "None", value: "" },
];

export const CLASSIFICATION_OPTIONS = [
  { label: "Goods", value: "Goods" },
  { label: "Service", value: "Service" },
  { label: "Capital Goods", value: "Capital Goods" },
];

export const SALES_TYPE_OPTION: GstRadioTypes[] = [
  {
    unique_id: "salesType",
    id: "B2B",
    _id: "Sales Type - B2B",
    name: "B2B",
  },
  {
    unique_id: "salesType",
    id: "B2C",
    _id: "Sales Type - B2C",
    name: "B2C",
  },
];

export const SEZ_TAX_PAYMENT_OPTION: GstRadioTypes[] = [
  {
    unique_id: "sezTaxPayment",
    id: "With Payment",
    _id: "Sez Tax With Payment",
    name: "Payment",
  },
  {
    unique_id: "sezTaxPayment",
    id: "Without Payment",
    _id: "Sez Tax Without Payment",
    name: "No Payment",
  },
];

export const SEZ_OPTION: GstRadioTypes[] = [
  {
    unique_id: "sez",
    id: "Yes",
    _id: "SEZ - Yes",
    name: "Yes",
  },
  {
    unique_id: "sez",
    id: "No",
    _id: "SEZ - No",
    name: "No",
  },
];

export const EXPORT_OPTION: GstRadioTypes[] = [
  {
    unique_id: "exports",
    id: "Yes",
    _id: "Export - Yes",
    name: "Yes",
  },
  {
    unique_id: "exports",
    id: "No",
    _id: "Export - No",
    name: "No",
  },
];

export const GSTR_2A_OPTIONS: GstRadioTypes[] = [
  {
    unique_id: "gstr2a",
    id: "Yes",
    _id: "GSTR2A -Yes",
    name: "Yes",
  },
  {
    unique_id: "gstr2a",
    id: "No",
    _id: "GSTR2A -No",
    name: "No",
  },
];
export const GSTR_2B_OPTIONS: GstRadioTypes[] = [
  {
    unique_id: "gstr2b",
    id: "Yes",
    _id: "GSTR2B - Yes",
    name: "Yes",
  },
  {
    unique_id: "gstr2b",
    id: "No",
    _id: "GSTR2B - No",
    name: "No",
  },
];
export const SELLER_TYPE: GstRadioTypes[] = [
  {
    unique_id: "sellerType",
    id: "B2B",
    _id: "B2B",
    name: "B2B",
  },
  {
    unique_id: "sellerType",
    id: "B2C",
    _id: "B2C",
    name: "B2C",
  },
];
export const WHEATHER_ELIGIBLE: GstRadioTypes[] = [
  {
    unique_id: "wheatherEligible",
    id: "Yes",
    _id: "Whether Eligible - Yes",
    name: "Yes",
  },
  {
    unique_id: "wheatherEligible",
    id: "No",
    _id: "Whether Eligible - No",
    name: "No",
  },
];
export const PURCHASE_FROM_COMPOSITION_DEALER_OPTION: GstRadioTypes[] = [
  {
    unique_id: "purchaseFromCompositionDealer",
    id: "Yes",
    _id: "Purchase From Composition Dealer - Yes",
    name: "Yes",
  },
  {
    unique_id: "purchaseFromCompositionDealer",
    id: "No",
    _id: "Purchase From Composition Dealer - No",
    name: "No",
  },
];

export const GSTR_SORTING_RADIO_OPTIONS: GstRadioTypes[] = [
  {
    unique_id: "invoice_date",
    id: "invoice_date_desc",
    _id: "desc",
    name: "Invoice Date - Descending",
  },
  {
    unique_id: "invoice_date",
    id: "invoice_date_asc",
    _id: "asc",
    name: "Invoice Date - Ascending",
  },
  {
    unique_id: "invoice_number",
    id: "invoice_number_asc",
    _id: "asc",
    name: "Invoice Number - Ascending",
  },
  {
    unique_id: "invoice_number",
    id: "invoice_number_desc",
    _id: "desc",
    name: "Invoice Number - Descending",
  },
  {
    unique_id: "total_invoice_value",
    id: "total_invoice_value_asc",
    _id: "asc",
    name: "Invoice Value - Ascending",
  },
  {
    unique_id: "total_invoice_value",
    id: "total_invoice_value_desc",
    _id: "desc",
    name: "Invoice Value - Descending",
  },
];

export const GSTR_INVOICE_HEADER: TableHeadersType[] = [
  {
    label: "Name",
    value: "name",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "Invoice No.",
    value: "invoice_no",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "Invoice Date",
    value: "invoice_date",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "Document Type",
    value: "document_type",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "Total Amount",
    value: "total_amount",
    defaultChecked: true,
    checked: true,
  },
  //commented for future use
  // {
  //     "label": "Added/Modified by",
  //     "value": "added_modified_by",
  //     "defaultChecked": true,
  //     "checked": true
  // },
  // {
  //     "label": "Status",
  //     "value": "status",
  //     "defaultChecked": true,
  //     "checked": true
  // }
];

export const headers = [
  {
    label: "DESCRIPTION",
    value: "description",
    defaultChecked: false,
    checked: false,
  },
  {
    label: "NO. OF RECORDS",
    value: "hsn_count",
    defaultChecked: false,
    checked: false,
  },
  {
    label: "DOCUMENT TYPE",
    value: "document_type",
    defaultChecked: false,
    checked: false,
  },
  {
    label: "VALUE",
    value: "value",
    defaultChecked: false,
    checked: false,
  },
  {
    label: "INTEGRATED TAX",
    value: "integrated_tax",
    defaultChecked: false,
    checked: false,
  },
  {
    label: "CENTRAL TAX",
    value: "central_tax",
    defaultChecked: false,
    checked: false,
  },
  {
    label: "STATE/UT TAX",
    value: "state_ut_tax",
    defaultChecked: false,
    checked: false,
  },
  {
    label: "CESS",
    value: "cess",
    defaultChecked: false,
    checked: false,
  },
];

export const singleHeaders = [
  {
    label: "DESCRIPTION",
    value: "description",
    defaultChecked: false,
    checked: false,
  },
];

export const gstrDataTemplate = (gstrOneData: any) => {
  return [
    {
      header:
        "4A. Taxable outward supplies made to registered persons (other than reverse charge supplies) - B2B Regular",
      isOpen: false,
      id: "4aTaxable",
      data: {
        description: "Total",
        ...gstrOneData?.gstr1_4a_data,
        src: false,
        srcData: [],
        isSource: true,
      },
    },
    {
      header:
        "4B. Taxable outward supplies made to registered persons attracting tax on reverse charge - B2B Reverse Charge",
      isOpen: false,
      id: "4bTaxable",
      data: {
        description: "Total",
        ...gstrOneData?.gstr1_4b_data,
        src: false,
        srcData: [],
        isSource: true,
      },
    },
    {
      header:
        "5A. Taxable outward inter-state supplies made to unregistered persons (where invoice value is more than Rs.2.5 Lakh (Till July 2024) & Rs.1 Lakh (From August 2024)) - B2CL (Large)",
      isOpen: false,
      id: "5ATaxable",
      data: {
        description: "Total",
        ...gstrOneData?.gstr1_5a_data,
        src: false,
        srcData: [],
        isSource: true,
      },
    },
    {
      header: "6A. Exports (with/without PMT)",
      isOpen: false,
      id: "6AExports",
      data: [
        {
          id: "gstr16A_export_with_payment",
          description: "EXPWP",
          ...gstrOneData?.gstr1_6a_data?.export_with_payment,
          src: false,
          srcData: [],
          isSource: true,
        },
        {
          id: "gstr16A_export_without_payment",
          description: "EXPWOP",
          ...gstrOneData?.gstr1_6a_data?.export_without_payment,
          src: false,
          srcData: [],
          isSource: true,
        },
      ],
    },
    {
      header: "6B. Supplies made to SEZ unit or SEZ developer - SEZWP/SEZWOP",
      isOpen: false,
      id: "6BSupplies",
      data: [
        {
          id: "gstr16B_sez_with_payment",
          description: "SEZWP",
          ...gstrOneData?.gstr1_6b_data?.sez_with_payment,
          src: false,
          srcData: [],
          isSource: true,
        },
        {
          id: "gstr16B_sez_without_payment",
          description: "SEZWOP",
          ...gstrOneData?.gstr1_6b_data?.sez_without_payment,
          src: false,
          srcData: [],
          isSource: true,
        },
      ],
    },
    {
      header: "6C. Deemed Exports - DE",
      isOpen: false,
      id: "6CDeemed",
      data: { description: "Total", src: false, srcData: [] },
    },
    {
      header:
        "7. Taxable supplies (Net of debit and credit notes) to unregistered persons (other than the supplies covered in Table 5) - B2CS (Others)",
      isOpen: false,
      id: "7Taxable",
      data: {
        description: "Total",
        ...gstrOneData?.gstr1_7_data,
        src: false,
        srcData: [],
        isSource: true,
      },
    },
    {
      header: "8. Nil rated, exempted and non GST outward supplies",
      isOpen: false,
      id: "8Nil",
      data: [
        {
          id: "gstr18_nill_rated",
          description: "NIL",
          ...gstrOneData?.gstr1_8_data?.nill_rated,
          src: false,
          srcData: [],
          isSource: true,
        },
        {
          description: "EXEMPTED",
          ...gstrOneData?.gstr1_8_data?.exempt_supply,
          src: false,
          id: "gstr18_exempt_supply",
          srcData: [],
          isSource: true,
        },
        {
          description: "NON GST",
          ...gstrOneData?.gstr1_8_data?.zero_rated,
          src: false,
          id: "gstr18_zero_rated",
          srcData: [],
          isSource: true,
        },
      ],
    },
    {
      header: "9A. Amendments",
      isOpen: false,
      id: "9AAmendments",
      data: { description: "Total", src: false, srcData: [] },
    },
    {
      header: "9B. Credit/Debit Notes (Registered) – CDNR & CDNUR",
      isOpen: false,
      id: "9BCredit/Debit",
      data: {
        registered: [
          {
            description: "9B - Credit/Debit Notes (Registered) - CDNR",
            withBackground: true,
            fullLength: true,
          },
          {
            description:
              "Total - Net off debit/credit notes (Debit notes - Credit notes)",
            ...gstrOneData?.gstr1_9b_data?.registered?.total,
          },
          {
            description:
              "Credit / Debit notes issued to registered person for taxable outward supplies in table 4 other than table 6 - B2B Regular",
            fullLength: true,
          },
          {
            id: "gstr19B_registered_regular",
            description: "Net Total (Debit notes - Credit notes)",
            ...gstrOneData?.gstr1_9b_data?.registered?.regular,
            isSource: true,
            src: false,
          },
          {
            description:
              "Credit / Debit notes issued to registered person for taxable outward supplies in table 4 other than table 6 - B2B Reverse charge",
            fullLength: true,
          },
          {
            id: "gstr19B_registered_reverse_charges",
            description: "Net Total (Debit notes - Credit notes)",
            ...gstrOneData?.gstr1_9b_data?.registered?.reverse_charges,
            isSource: true,
            src: false,
          },
          {
            description:
              "Credit / Debit notes issued to registered person for taxable outward supplies in table 6B - SEZWP/SEZWOP",
            fullLength: true,
          },
          {
            id: "gstr19B_sez_with_payment",
            description: "Net Total (Debit notes - Credit notes)",
            ...gstrOneData?.gstr1_9b_data?.registered?.sez_with_payment,
            key: "9BCredit/Debit(6B-SEZWP/SEZWOP)",
            isSource: true,
            src: false,
          },
          {
            description:
              "Credit / Debit notes issued to registered person for taxable outward supplies in table 6C - DE",
            fullLength: true,
          },
          {
            description: "Net Total (Debit notes - Credit notes)",
            ...gstrOneData?.gstr1_9b_data?.registered?.demmed_exports,
          },
        ],
        unRegistered: [
          { description: "", fullLength: true, noBorder: true },
          {
            description: "9B - Credit/Debit Notes (Unregistered) - CDNUR",
            withBackground: true,
            fullLength: true,
            key: "9BCredit/Debit(unregistered)",
          },
          {
            description:
              "Total - Net off debit/credit notes (Debit notes - Credit notes)",
            ...gstrOneData?.gstr1_9b_data?.unregistered?.total,
            key: "9BCredit/Debit(unregistered)",
          },
          {
            description: "Unregistered Type",
            fullLength: true,
            key: "9BCredit/Debit(unregistered)",
          },
          {
            id: "gstr19B_unregistered_b2cl",
            description: "- B2CL",
            ...gstrOneData?.gstr1_9b_data?.unregistered?.b2cl,
            key: "9BCredit/Debit(unregistered)",
            isSource: true,
            src: false,
          },
          {
            id: "gstr19B_unregiestered_export_with_payment",
            description: "- EXPWP",
            ...gstrOneData?.gstr1_9b_data?.unregistered?.export_with_payment,
            key: "9BCredit/Debit(unregistered)",
            isSource: true,
            src: false,
          },
          {
            id: "gstr19B_unregistered_export_without_payment",
            description: "- EXPWOP",
            ...gstrOneData?.gstr1_9b_data?.unregistered?.export_without_payment,
            key: "9BCredit/Debit(unregistered)",
            isSource: true,
            src: false,
          },
        ],
      },
    },
    {
      header:
        "9C. Amended Credit/Debit Notes (Registered) - CDNRA & (Unregistered) CDNURA",
      isOpen: false,
      id: "9CAmended",
      data: { description: "Total", src: false, srcData: [] },
    },
    {
      header:
        "10. Amendment to taxable outward supplies made to unregistered person in returns for earlier tax periods in table 7 - B2C (Others)",
      isOpen: false,
      id: "10Amendment",
      data: { description: "Total", src: false, srcData: [] },
    },
    {
      header:
        "11A(1), 11A(2). Advances received for which invoice has not been issued (tax amount to be added to the output tax liability) (Net of refund vouchers)",
      isOpen: false,
      id: "11AAdvances",
      data: { description: "Total", src: false, srcData: [] },
    },
    {
      header:
        "11B(1), 11B(2). Advance amount received in earlier tax period and adjusted against the supplies being shown in this tax period in Table Nos. 4, 5, 6 and 7",
      isOpen: false,
      id: "11AAdvances",
      data: { description: "Total", src: false, srcData: [] },
    },
    {
      header:
        "11A. Amendment to advances received in returns for earlier tax periods in table 11A(1), 11A(2)",
      isOpen: false,
      id: "11AAmendment",
      data: { description: "Total", src: false, srcData: [] },
    },
    {
      header:
        "11B. Amendment to advances adjusted in returns for earlier tax periods in table 11B(1), 11B(2)",
      isOpen: false,
      id: "11BAmendment",
      data: { description: "Total", src: false, srcData: [] },
    },
    {
      header: "12. HSN-wise summary of outward supplies",
      isOpen: false,
      id: "12HSN",
      data: [
        {
        id: "gstr112",
        description: "Total",
        ...gstrOneData?.gstr1_12_data?.total,
        src: false,
        srcData: [],
        isSource: true,
        },
        {
          id: "gstr112B2B",
          description: "B2B",
          ...gstrOneData?.gstr1_12_data?.b2b,
          src: false,
          srcData: [],
          isSource: true,
        },
        {
          id: "gstr112B2C",
          description: "B2C",
          ...gstrOneData?.gstr1_12_data?.b2c,
          src: false,
          srcData: [],
          isSource: true,
        },
      ], 
    },
    {
      header: "13. Documents issued",
      isOpen: false,
      id: "13Documents",
      data: {
        description: "Total",
        ...gstrOneData?.gstr1_13_data,
        src: false,
        srcData: [],
        isSource: true,
      },
    },
  ];
};

export const GSTR_INVOICE2A_HEADER: TableHeadersType[] = [
  {
    label: "",
    value: "",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "",
    value: "compare",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "Invoice No.",
    value: "invoice_number",
    defaultChecked: true,
    checked: true,
  },

  {
    label: "Gst No.",
    value: "gst_number",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "Invoice Date",
    value: "invoice_date",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "Invoice Type",
    value: "invoice_type",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "Place Of Supply",
    value: "place_of_supply",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "Supply Attract Reverse Charge",
    value: "supply_attract_reverse_charge",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "Total Invoice Value",
    value: "total_invoice_value",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "Source Type",
    value: "source_type",
    defaultChecked: true,
    checked: true,
  },
  // {
  //   label: "Rate",
  //   value: "rate",
  //   defaultChecked: true,
  //   checked: true,
  // },
  // {
  //   label: "Total Taxable Value",
  //   value: "total_taxable_value",
  //   defaultChecked: true,
  //   checked: true,
  // },
  // {
  //   label: "Integrated Tax",
  //   value: "integrated_tax",
  //   defaultChecked: true,
  //   checked: true,
  // },
  // {
  //   label: "Central Tax",
  //   value: "central_tax",
  //   defaultChecked: true,
  //   checked: true,
  // },
  // {
  //   label: "State/UT Tax",
  //   value: "state_ut_tax",
  //   defaultChecked: true,
  //   checked: true,
  // },
  {
    label: "Irn Generate Date",
    value: "irn_generate_date",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "Irn",
    value: "irn",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "GSTR-1/IFF/GSTR-5 Filing status",
    value: "gstr1_iff_gstr5_filing_status",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "GSTR-1/IFF/GSTR-5 Filing Date",
    value: "gstr1_5_filing_date",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "GSTR-1/IFF/GSTR-5 Filing Period",
    value: "gstr1_5_filing_period",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "GSTR-3B Filing Status",
    value: "gstr3b_filing_status",
    defaultChecked: true,
    checked: true,
  },
];

export const GSTR_INVOICE2B_HEADER: TableHeadersType[] = [
  {
    label: "",
    value: "",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "",
    value: "compare",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "Invoice No.",
    value: "invoice_number",
    defaultChecked: true,
    checked: true,
  },

  {
    label: "Invoice Date",
    value: "invoice_date",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "Invoice Type",
    value: "invoice_type",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "Supplier Gst",
    value: "supplier_gst",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "Supplier Trade Legal Name",
    value: "supplier_trade_legal_name",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "Place Of Supply",
    value: "place_of_supply",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "Supply Attract Reverse Charge",
    value: "supply_attract_reverse_charge",
    defaultChecked: true,
    checked: true,
  },

  {
    label: "Total IGST Amount",
    value: "total_igst_amount",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "Total CGST Amount",
    value: "total_cgst_amount",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "Total SGST Amount",
    value: "total_sgst_amount",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "Total CESS Amount",
    value: "total_cess_amount",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "Total Invoice Value",
    value: "invoice_value",
    defaultChecked: true,
    checked: true,
  },
  // {
  //   label: "Cess",
  //   value: "cess",
  //   defaultChecked: true,
  //   checked: true,
  // },
  // {
  //   label: "Total Taxable Value",
  //   value: "total_taxable_value",
  //   defaultChecked: true,
  //   checked: true,
  // },
  // {
  //   label: "Integrated Tax",
  //   value: "integrated_tax",
  //   defaultChecked: true,
  //   checked: true,
  // },
  // {
  //   label: "Central Tax",
  //   value: "central_tax",
  //   defaultChecked: true,
  //   checked: true,
  // },
  // {
  //   label: "State Tax",
  //   value: "state_tax",
  //   defaultChecked: true,
  //   checked: true,
  // },
  {
    label: "Irn Generate Date",
    value: "irn_generate_date",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "Irn",
    value: "irn",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "GSTR-1/IFF/GSTR-5 Filing Date",
    value: "date_of_gstr1_5_filing_of_supplier",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "GSTR-1/IFF/GSTR-5 Filing Period",
    value: "filing_period_of_gstr1_5_of_supplier",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "Itc Availability",
    value: "itc_availability",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "Source Type",
    value: "source_type",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "Reason",
    value: "reason",
    defaultChecked: true,
    checked: true,
  },
];

export const GSTR2A2B_ITEM_HEADER: TableHeadersType[] = [
  {
    label: "CESS AMOUNT",
    value: "cess_amount",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "IGST AMOUNT",
    value: "igst_amount",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "CGST AMOUNT",
    value: "cgst_amount",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "SGST AMOUNT",
    value: "sgst_amount",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "GST RATE",
    value: "gst_rate",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "TAXABLE VALUE",
    value: "taxable_value",
    defaultChecked: true,
    checked: true,
  },
];
